import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

/**
 * Type predicate to narrow an unknown error to `FetchBaseQueryError`
 */
export function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
    return typeof error === 'object' && error != null && 'status' in error;
}

/**
 * Type predicate to narrow an unknown error to an object with a string 'message' property
 */
export function isErrorWithMessage(error: unknown): error is { message: string } {
    return typeof error === 'object' && error != null && 'message' in error && typeof error.message === 'string';
}

export const checkRequestStatus = (res: unknown, message: string) => {
    if (typeof res !== 'object' || res == null) return;

    if ('error' in res) {
        const errorObj = res.error;
        if (isFetchBaseQueryError(errorObj)) {
            const errorMsg = isErrorWithMessage(errorObj.data) ? errorObj.data.message : JSON.stringify(errorObj.data);
            throw new Error(errorMsg);
        }
        throw new Error(message);
    }
};
